import type { PermissoesAppInforcfc } from './permissions.types';
import { permissoesPorFuncionalidades } from './permissoesPorFuncionalidades.config';
import { checkPermission, mapObject } from './utils';

export const mapPermissoes = (
  userPermissoesRequest: string[] | null | undefined
): PermissoesAppInforcfc => {
  const isAdmin = !userPermissoesRequest;

  if (isAdmin) {
    return {
      isAdmin,
      homePage: true,
      aluno: true,
      aulas: true,
      exames: true,
      recibos: true,
      bancoDigital: true,
      despesas_receitas: true,
      despesas: true,
      matriculas: true,
      marketing: true,
      marketingNovoModelo: true,
      protocolosProdesp: true,
      home: mapObject(permissoesPorFuncionalidades.home, () => true),
      abrirAlunoPerfil: true,
      alunoPerfil: mapObject(
        permissoesPorFuncionalidades.alunoPerfil,
        () => true
      ),
    };
  }

  const permissionsSet = new Set(
    userPermissoesRequest.map((perm) => perm.toLowerCase())
  );

  const result: PermissoesAppInforcfc = {
    isAdmin,
    homePage: checkPermission(
      permissoesPorFuncionalidades.homePage,
      permissionsSet,
      true
    ),
    aluno: checkPermission(permissoesPorFuncionalidades.aluno, permissionsSet),
    aulas: checkPermission(permissoesPorFuncionalidades.aulas, permissionsSet),
    exames: checkPermission(
      permissoesPorFuncionalidades.exames,
      permissionsSet
    ),
    recibos: checkPermission(
      permissoesPorFuncionalidades.recibos,
      permissionsSet
    ),
    bancoDigital: checkPermission(
      permissoesPorFuncionalidades.bancoDigital,
      permissionsSet
    ),
    despesas_receitas: checkPermission(
      permissoesPorFuncionalidades.despesas_receitas,
      permissionsSet
    ),
    despesas: checkPermission(
      permissoesPorFuncionalidades.despesas,
      permissionsSet
    ),
    matriculas: checkPermission(
      permissoesPorFuncionalidades.matriculas,
      permissionsSet
    ),
    marketing: checkPermission(
      permissoesPorFuncionalidades.marketing,
      permissionsSet
    ),
    marketingNovoModelo: checkPermission(
      permissoesPorFuncionalidades.marketingNovoModelo,
      permissionsSet
    ),
    protocolosProdesp: checkPermission(
      permissoesPorFuncionalidades.protocolosProdesp,
      permissionsSet
    ),
    home: mapObject(permissoesPorFuncionalidades.home, (_key, value) =>
      checkPermission(value, permissionsSet)
    ),
    abrirAlunoPerfil: checkPermission(
      permissoesPorFuncionalidades.abrirAlunoPerfil,
      permissionsSet,
      true
    ),
    alunoPerfil: mapObject(
      permissoesPorFuncionalidades.alunoPerfil,
      (_key, value) => checkPermission(value, permissionsSet)
    ),
  };

  return result;
};
